import { isBlockTypeActive } from './isBlockTypeActive.js'

const validParentNodeTypes = [
  'paragraph'
]

export function isInlineCheckboxFeasible (editor) {
  for (const type of validParentNodeTypes) {
    if (isBlockTypeActive(editor, type)) {
      return true
    }
  }

  return false
}
